import * as React from "react"
import { cn } from "../../lib/utils"

// Need to install @radix-ui/react-progress first, or implemented simple version
// Simple version to avoid install if possible, but radix is better.
// Let's implement simple version for speed if radix not guaranteed, but I installed radix-dialog. I should install radix-progress.
// Or just simple div implementation.

const Progress = React.forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement> & { value?: number | null }
>(({ className, value, ...props }, ref) => (
    <div
        ref={ref}
        className={cn(
            "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
            className
        )}
        {...props}
    >
        <div
            className="h-full w-full flex-1 bg-primary transition-all"
            style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
        />
    </div>
))
Progress.displayName = "Progress"

export { Progress }
